import { Stack, Typography } from "@mui/material"

export function DetailColumn({ label, value }) {
    return (
        <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
            <Typography
                color="text.secondary"
                sx={{
                    textTransform: "uppercase",
                    fontSize: 12,
                    fontWeight: 700,
                    lineHeight: "22px",
                    letterSpacing: 0.5,
                }}
            >
                {label}
            </Typography>
            <Typography noWrap title={value} sx={{ fontSize: 16, fontWeight: 400, lineHeight: "22px" }}>
                {value}
            </Typography>
        </Stack>
    )
}
